import StringFormat from '../../utils/StringFormat'
import ApiManager from '../../utils/ApiManager'
import Constants from '../../utils/Constants'

const state = {
  loadingNews: false,
  newsItems: [],
  private_reports: [],
  public_reports: [],
  ages: null,
  message: {
    content: '',
    type: ''
  },
  reports_loaded: false
}

const actions = {
  getInitData ({ dispatch, state, commit }) {
    commit('init')
    dispatch('getNewsData')
  },
  /**
   * お知らせデータ取得
   */
  async getNewsData ({ state, commit }) {
    // commit('setNewsLoading', true)
    const response = await ApiManager.request('Notice').noticeUserList()
    commit('setNews', response.data)
  },
  /**
   * ダッシュボード情報を取得する
   */
  async initDashboard ({ state, commit }) {
    this.dispatch('loading/loadingPagePlus')
    const response = await ApiManager.request('Dashboard').dashboard()
    let type = 'success'
    if (response && response.data) {
      if (response.data.code === Constants.ResponseCode.SUCCESS) {
        commit('setReport', response.data.data)
      } else if (response.data.code === Constants.ResponseCode.VALIDATE_ERROR) {
        type = 'error'
      }
      commit('setMessage', { content: response.data.data.message, type: type })
    }
    this.dispatch('loading/loadingPageMinus')
  },
  setReportsLoaded ({ state, commit }, status) {
    commit('setReportsLoaded', status)
  },
  /**
   * マイレポート、企業レポートの表示順変更を行う
   */
  async viewOrder ({ state, commit }, payload) {
    this.dispatch('loading/loadingPagePlus')
    const response = await ApiManager.request('Dashboard').dashboardViewOrder(payload)
    let type = 'success'
    if (response.data.code === Constants.ResponseCode.SUCCESS) {
    } else if (response.data.code === Constants.ResponseCode.VALIDATE_ERROR) {
      type = 'error'
    }
    commit('setMessage', { content: response.data.data.message, type: type })
    this.dispatch('loading/loadingPageMinus')
  },
  /**
   * 予約設定されたレポートを取得する
   */
  async getResultData ({ state, commit }, report) {
  }
}

const mutations = {
  init (state, data) {
    state.message = {
      content: '',
      type: ''
    }
  },
  setMessage (state, data) {
    state.message = data
  },
  setNewsLoading (state, data) {
    state.loadingNews = data
  },
  setNews (state, data) {
    for (let i = 0; i < data.data.length; i++) {
      data.data[i].display_from = StringFormat.ymdhmFormat(data.data[i].display_from)
    }
    state.newsItems = data.data
    state.loadingNews = false
  },
  setReport (state, data) {
    state.private_reports = data.private
    state.public_reports = data.public
    state.ages = data.ages
  },
  setReportsLoaded (state, data) {
    state.reports_loaded = data
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
